export const FETCH_PROJECTS_LOADING = '@@projects/LOADING';
export const FETCH_PROJECTS_SUCCESS = '@@projects/SUCCESS';
export const FETCH_PROJECTS_FAILURE = '@@projects/FAILURE';

export const UPDATE_PROJECT_LOADING = '@@projects/UPDATE_LOADING';
export const UPDATE_PROJECT_SUCCESS = '@@projects/UPDATE_SUCCESS';
export const UPDATE_PROJECT_FAILURE = '@@projects/UPDATE_FAILURE';
